import React, { FunctionComponent, useEffect, useState } from 'react';
import withContext from '../../../ContextAPI/Context_HOC';
import CongressionalOutreachHeader from '../CongressionalOutreachHeader';
import CongressionalOutreachFooter from '../CongressionalOutreachFooter';
import CongressionalOutreachSubpageProxy from './CongressionalOutreachSubpageProxy';
import NoMatch from '../../../Routers/NoMatch';
import { Col, Row } from 'react-flexbox-grid';
import { OpaCongressionalOutreachEnriched } from './Models/OpaCongressionalOutreachEnriched';
import CongressionalOutreachRichContent from './CongressionalOutreachRichContent';
import CongressionalOutreachSubpageLinks from './CongressionalOutreachSubpageLinks';
import CircularProgress from '@material-ui/core/CircularProgress';

const CongressionalOutreachSubpage: FunctionComponent<{
  match: { params: { id: string } };
  context: { congressionalOutreachSubpageProxy: CongressionalOutreachSubpageProxy };
}> = ({ match, context: { congressionalOutreachSubpageProxy } }) => {
  const urlSlug = match.params.id;
  const [loading, setLoading] = useState<boolean>(true);
  const [errorOccurred, setErrorOccurred] = useState<boolean>(false);
  const [article, setArticle] = useState<OpaCongressionalOutreachEnriched | null>(null);
  const [links, setLinks] = useState<{ urlSlug: string; linkText: string }[]>([]);

  useEffect(() => {
    const outreachSubpageSubscription = congressionalOutreachSubpageProxy.getOutreachSubpage(urlSlug).subscribe({
      next: (article) => {
        setArticle(article);
        setLoading(false);
      },
      error: (error) => {
        console.error(error);
        setErrorOccurred(true);
      },
    });

    const outreachSubpageImagesSubscription = congressionalOutreachSubpageProxy.getOutreachSubpageImages().subscribe((x) => {
      const imageUrls = x.map((article) => ({
        urlSlug: article.urlSlug.value,
        linkText: article.system.name,
      }));
      setLinks(imageUrls);
    });

    return () => {
      outreachSubpageSubscription.unsubscribe();
      outreachSubpageImagesSubscription.unsubscribe();
    };
  }, [urlSlug, congressionalOutreachSubpageProxy]);

  if (errorOccurred) {
    return <NoMatch />;
  }

  if (loading || !article) {
    return <CircularProgress className="loading-animation" size={40} />;
  }
  return (
    <>
      <CongressionalOutreachHeader subtitle={article.baseTitle.value} />
      <Row>
        <Col sm={8}>
          <CongressionalOutreachRichContent baseBody={article.baseBody.value} modularContent={article.linkedItems} />
        </Col>
        <Col sm={4}>
          <CongressionalOutreachSubpageLinks currentSlug={urlSlug} linksList={links} />
        </Col>
      </Row>
      <CongressionalOutreachFooter />
    </>
  );
};
export default withContext(CongressionalOutreachSubpage);
